import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');
  return { headers: { Authorization: `Bearer ${token}` } };
};

export const fetchAdminProducts = createAsyncThunk('adminProducts/fetchProducts', async (_, { rejectWithValue }) => {
  try {
    const res = await axios.get('http://localhost:5000/api/admin/products', getAuthHeaders());
    return res.data.products;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Failed to fetch products');
  }
});

export const deleteAdminProduct = createAsyncThunk('adminProducts/deleteProduct', async (id, { rejectWithValue }) => {
  try {
    await axios.delete(`http://localhost:5000/api/admin/products/${id}`, getAuthHeaders());
    return id;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Failed to delete product');
  }
});

const adminProductsSlice = createSlice({
  name: 'adminProducts',
  initialState: {
    products: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminProducts.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchAdminProducts.fulfilled, (state, action) => { state.loading = false; state.products = action.payload; })
      .addCase(fetchAdminProducts.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(deleteAdminProduct.fulfilled, (state, action) => {
        state.products = state.products.filter(p => p._id !== action.payload);
      });
  }
});

export default adminProductsSlice.reducer;
